import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface HelpIconProps extends IconWrapperProps {
  color?: string;
}

const HelpIcon = ({ color, ...rest }: HelpIconProps) => (
  <IconWrapper viewBox="0 0 23 23" width="23px" height="23px" {...rest}>
    <g
      id="help-icon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" transform="translate(4.000000, 0.000000)">
        <circle
          id="Oval"
          stroke={color || "currentColor"}
          strokeWidth="1.2"
          cx="8"
          cy="11.4"
          r="7.4"
        />
        <path
          d="M8.52442912,12.8921875 C8.53224162,12.3296875 8.66505412,11.9019531 8.92286662,11.6089844 L8.92286662,11.6089844 L9.64356975,10.9 C10.2373197,10.2828125 10.5341947,9.65585937 10.5341947,9.01914062 C10.5341947,8.30429687 10.3144682,7.74765625 9.87501506,7.34921875 C9.43556194,6.95078125 8.82325725,6.7515625 8.038101,6.7515625 C7.27638225,6.7515625 6.66407756,6.95273437 6.20118694,7.35507812 C5.73829631,7.75742187 5.50294475,8.30429687 5.49513225,8.99570312 L5.49513225,8.99570312 L6.91896037,8.99570312 C6.91896037,8.67148437 7.02149944,8.41464844 7.22657756,8.22519531 C7.43165569,8.03574219 7.7021635,7.94101562 8.038101,7.94101562 C8.3896635,7.94101562 8.65626506,8.03769531 8.83790569,8.23105469 C9.01954631,8.42441406 9.11036662,8.7046875 9.11036662,9.071875 C9.11036662,9.34921875 9.03224162,9.60703125 8.87599162,9.8453125 C8.77442912,10.0015625 8.53321819,10.2642578 8.15235881,10.6333984 C7.77149944,11.0025391 7.51661662,11.3414062 7.38771037,11.65 C7.25880412,11.9585937 7.194351,12.3726562 7.194351,12.8921875 L7.194351,12.8921875 L8.52442912,12.8921875 Z M7.897476,15.4703125 C8.1552885,15.4703125 8.35450725,15.3980469 8.49513225,15.2535156 C8.63575725,15.1089844 8.70606975,14.9292969 8.70606975,14.7144531 C8.70606975,14.4917969 8.63380412,14.3072266 8.48927287,14.1607422 C8.34474162,14.0142578 8.147476,13.9410156 7.897476,13.9410156 C7.65138225,13.9410156 7.45606975,14.0123047 7.3115385,14.1548828 C7.16700725,14.2974609 7.09474162,14.4839844 7.09474162,14.7144531 C7.09474162,14.9292969 7.16407756,15.1089844 7.30274944,15.2535156 C7.44142131,15.3980469 7.6396635,15.4703125 7.897476,15.4703125 Z"
          id="?"
          fill={color || "currentColor"}
          fillRule="nonzero"
        />
      </g>
    </g>
  </IconWrapper>
);

export default memo(HelpIcon);
